// Semantic design tokens for the pipeline-monitoring views, so the components below
// consume colors/radii by role instead of hardcoding hex. All hex values live in the
// centralized `colors` registry in src/app/styleSheet.js — this module only maps those
// raw colors onto pipeline-monitoring semantics (status fills, edges, chrome, drawer).
import { colors } from '../../styleSheet';

// Node status fills + readable foreground ("ink") for each pipeline state.
export const STATUS_COLORS = {
  ready: { fill: colors.success, ink: colors.primary },
  processing: { fill: colors.white, ink: colors.primary },
  noPolicies: { fill: colors.statusNoPolicies, ink: colors.primary },
  alert: { fill: colors.danger, ink: colors.white },
};

// Edge stroke colors per state (same semantics as the node fills).
export const EDGE_COLORS = {
  ready: colors.success,
  noPolicies: colors.statusNoPolicies,
  alert: colors.error,
  neutral: colors.slate400,
};

// Shared UI roles used by the chips, breadcrumbs and node chrome.
export const UI = {
  textPrimary: colors.primary,
  textSecondary: colors.slate600,
  textMuted: colors.slate400,
  textInverse: colors.white,
  surface: colors.white,
  surfaceMuted: colors.slate50,
  border: colors.slate200,
  danger: colors.danger,
  radiusButton: '8px',
  radiusCard: '12px',
  radiusPill: '16px',
};

// Shared typography for the toolbar filter fields (search, chain/store autocompletes), so
// every input in the pipeline-monitoring toolbar reads consistently (14px secondary grey)
// from one source instead of per-field `sx` copies that drift apart.
export const FILTER_INPUT_SX = {
  '& .MuiInputBase-input': { fontSize: 14, color: colors.textGray },
  '& .MuiInputBase-input::placeholder': {
    fontSize: 14,
    color: colors.textGray,
    opacity: 1,
  },
};

// Dark surface tokens for the selected-process info drawer (kept dark to match the
// existing detail panel; the accent ties back to the graph's "completed" green).
export const DRAWER = {
  surface: colors.drawerSurface,
  surfaceAlt: colors.drawerSurfaceAlt,
  surfaceAltHover: colors.drawerBorder,
  border: colors.drawerBorder,
  text: colors.drawerText,
  textMuted: colors.drawerTextMuted,
  accent: colors.success,
  radius: '10px',
};
